import { BaseCandidateFieldConfig, Candidate, CandidateFieldConfig } from '~/definitions/candidates';

export const CANDIDATE_FIELD_CONFIG: BaseCandidateFieldConfig[] = [
    {
        id: 'ballot_number',
        key: 'ballotNumber',
        name: 'Nummer på stemmeseddel',
    },
    {
        id: 'last_name',
        key: 'lastName',
        name: 'Etternavn',
    },
    {
        id: 'first_name',
        key: 'firstName',
        name: 'Fornavn',
    },
    {
        id: 'occupation',
        key: 'occupation',
        name: 'Yrke',
    },
    {
        id: 'city',
        key: 'city',
        name: 'Sted',
    },
    {
        id: 'pre_cumulated',
        key: 'preCumulated',
        name: 'Forh. kumulert',
    },
    {
        id: 'picture',
        key: 'picture',
        name: 'Bilde',
    },
];

export const CANDIDATE_FIELD_CONFIG_LEFT: CandidateFieldConfig[] = [
    {
        id: 'firstname',
        key: 'firstName',
        name: 'Fornavn',
        type: 'text',
        isRequired: true,
    },
    {
        id: 'lastname',
        key: 'lastName',
        name: 'Etternavn',
        type: 'text',
        isRequired: true,
    },
    {
        id: 'zipcode',
        key: 'postNumber',
        name: 'Postnr',
        type: 'text',
    },
    {
        id: 'city',
        key: 'city',
        name: 'Sted',
        type: 'text',
    },
    {
        id: 'job',
        key: 'occupation',
        name: 'Stilling',
        type: 'text',
    },
    {
        id: 'priority',
        key: 'ballotNumber',
        name: 'Nummer på stemmeseddel',
        type: 'text',
    },
    {
        id: 'kumuler',
        key: 'preCumulated',
        name: 'Forh. kumuler',
        type: 'select',
    },
    {
        id: 'picture',
        key: 'picture',
        name: 'Bilde (filtype .jpg eller .gif)',
        type: 'file',
        accept: '.jpg,.jpeg,.gif',
    },
    {
        id: 'candidate_consent',
        key: 'isConsentReceived',
        name: 'Har du fått samtykke til å dele denne kandidatens personlige data?',
        type: 'checkbox',
    },
];

export const CANDIDATE_FIELD_CONFIG_RIGHT: CandidateFieldConfig[] = [
    {
        id: 'gender',
        key: 'gender',
        name: 'Kjønn',
        type: 'select',
    },
    {
        id: 'dateOfBirth',
        key: 'dateOfBirth',
        name: 'Fødselsdato',
        type: 'datepicker',
    },
    {
        id: 'case',
        key: 'case',
        name: 'Hvorfor velge meg? (Maks. 40 tegn)',
        type: 'textarea',
    },
    {
        id: 'description',
        key: 'description',
        name: 'Beskrivelse (Maks. 240 tegn)',
        type: 'textarea',
    },
];

export const CANDIDATE_OPTIONS = {
    preCumulated: [
        { value: 'false', label: 'Ikke forhåndskumulert' },
        { value: 'true', label: 'Forhåndskumulert' },
    ],
};

export const DEFAULT_REGIONS = [{ id: '', name: '' }];

export const DEFAULT_CANDIDATE: Candidate = {
    id: '',
    ballotNumber: '',
    firstName: '',
    lastName: '',
    occupation: '',
    preCumulated: 'false',
    picture: '',
    postNumber: '',
    city: '',
    gender: '',
    dateOfBirth: '',
    case: '',
    description: '',
    isConsentReceived: false,
};

export const CANDIDATES_ATTRIBUTES_NUMBERS = {
    candidate_first_name: 'candidate_first_name',
    candidate_last_name: 'candidate_last_name',
    candidate_job_position: 'candidate_job_position',
    candidate_cumulation: 'candidate_cumulation',
    candidate_zip_code: 'candidate_zip_code',
    candidate_priority: 'candidate_priority',
    candidate_city: 'candidate_city',
    candidate_gender: 'candidate_gender',
    candidate_birthdate: 'candidate_birthdate',
    candidate_slogan: 'candidate_slogan',
    candidate_description: 'candidate_description',
    candidate_consent: 'candidate_consent',
};

export const candidateAttributeNumberKeys = Object.values(CANDIDATES_ATTRIBUTES_NUMBERS);

export const DELETE_CONFIRMATION_MESSAGE = 'Du er nå i ferd med à slette kandidaten';

export const CANDIDATE_SELECT_OPTIONS_NUMBERS: (keyof typeof CANDIDATES_ATTRIBUTES_NUMBERS)[] = ['candidate_gender'];

export const COPY_COMPLETE_MESSAGE = 'Kandidaten er kopiert';
export const COPY_FAIL_MESSAGE = 'Det oppstod en feil.';

export const DEFAULT_GET_CATEGORY_PRODUCT_PAGE = 0;
export const DEFAULT_GET_CATEGORY_PRODUCT_PAGE_SIZE = 1000;

export const FALLBACK_CANDIDATE_IMAGE_PATH = {
    MALE: `/elements/print/candidate-male.jpg`,
    FEMALE: `/elements/print/candidate-female.jpg`,
};
